export enum BatchesQueryKeys {
	GetBatches = 'batches.getBatches',
	GetCoupons = 'batches.getCoupons',
	GetCouponsForBrokeNotification = 'batches.getCouponsForBrokeNotification',
	GetBatchesForBrokeNotification = 'batches.getBatchesForBrokeNotification',
	GetUsageHistory = 'batches.getUsageHistory',
}

export enum BatchesMutationKeys {
	CreateBatch = 'batches.createBatch',
	UpdateBatch = 'batches.updateBatch',
	DeleteBatch = 'batches.deleteBatch',
}
